import { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './mobile-site.css';

const links = [
  ['Home', '/'], ['Services', '/services'], ['Event photos', '/gallery'],
  ['Pole & Polaroids', '/pole-and-polaroids'],
  ['The Naughty List', '/pole-and-polaroids/naughty-list'],
  ['Explore the tour', '/tour'], ['Fund the tour', '/fun'],
  ['About Fotos', '/about-fotos-on-the-geaux'], ['Guides', '/insights'],
];

export default function SiteFrame({ children }) {
  const location = useLocation();
  const menu = useRef(null);
  const internal = /^\/(admin|rook|cards|payment|checkout)(\/|$)/.test(location.pathname);
  useEffect(() => { if (menu.current) menu.current.open = false; }, [location]);
  if (internal) return children;
  const close = () => { if (menu.current) menu.current.open = false; };
  return <div className="public-site-shell">
    <header className="mobile-site-nav">
      <Link to="/" className="mobile-site-brand" aria-label="Fotos on the Geaux home">FOTOS<span>ON THE GEAUX</span></Link>
      <Link to="/book" className="mobile-site-book">Book Fotos</Link>
      <details ref={menu} className="mobile-site-menu" onKeyDown={e => {
        if (e.key === 'Escape') { close(); menu.current?.querySelector('summary')?.focus(); }
      }} onBlur={e => { if (!e.currentTarget.contains(e.relatedTarget)) close(); }}>
        <summary aria-label="Site menu"><span className="menu-closed">Menu ☰</span><span className="menu-open">Close ×</span></summary>
        <nav aria-label="Mobile site navigation" className="mobile-site-links">
          {links.map(([label,path]) => <Link key={path} to={path} onClick={close} aria-current={location.pathname.replace(/\/$/,'') === path.replace(/\/$/,'') ? 'page' : undefined}>{label}<span aria-hidden="true">↗</span></Link>)}
          {location.pathname.startsWith('/tour') && <><a href="#cities" onClick={close}>Find your city <span aria-hidden="true">↓</span></a><a href="#partners" onClick={close}>Tour partnerships <span aria-hidden="true">↓</span></a></>}
          {location.pathname.startsWith('/pole-and-polaroids') && <a href="https://fotos.geauxfotos.com/e/pole-polaroids/feedback">Leave feedback <span aria-hidden="true">↗</span></a>}
        </nav>
      </details>
    </header>
    <div className="site-route-content">{children}</div>
  </div>;
}
